/**
 * Felező függvény, hogy ne kelljen a magic-numberrel szenvednünk.
 * @param {number} num - A szám, amit felezni akarunk.
 * @returns {number} A szám fele.
 */
module.exports.half = function half (num) {
  return num / 2
}
